import {apply, bind} from 'ramda';

const replaceWithTo = bind(Element.prototype.replaceWith);

/**
 *
 * @param {Array<string | Node>|NodeList} nodes
 * @param {HTMLElement} context
 */
export default function replaceWith(nodes, context) {
    const replaceWith = replaceWithTo(context);

    return apply(replaceWith, nodes);
}
